// A regular detached canvas keeps this optimization available on older browsers.
// Each renderer owns a bounded number of layers; a changed key replaces the bitmap.
export class CanvasLayerCache {
    private canvas: HTMLCanvasElement | null = null;
    private key = "";

    draw(context: CanvasRenderingContext2D, width: number, height: number, ratio: number,
        key: string, paint: (layer: CanvasRenderingContext2D) => void, cache = true) {
        if (!cache) {
            paint(context);
            return;
        }
        // Bound each decorative bitmap to 8 MiB even on large HiDPI displays.
        ratio = Math.min(ratio, Math.sqrt(2_097_152 / Math.max(1, width * height)));
        const cacheKey = `${width}:${height}:${ratio}:${key}`;
        const canvas = this.canvas ?? (this.canvas = document.createElement("canvas"));
        if (this.key !== cacheKey) {
            canvas.width = Math.max(1, Math.round(width * ratio));
            canvas.height = Math.max(1, Math.round(height * ratio));
            const layer = canvas.getContext("2d");
            if (!layer) {
                paint(context);
                return;
            }
            layer.setTransform(ratio, 0, 0, ratio, 0, 0);
            paint(layer);
            this.key = cacheKey;
        }
        context.drawImage(canvas, 0, 0, width, height);
    }

    destroy() {
        if (this.canvas) {
            this.canvas.width = this.canvas.height = 1;
        }
        this.canvas = null;
        this.key = "";
    }
}
